import { render, staticRenderFns } from "./Transistor.vue?vue&type=template&id=86342ce0&lang=pug&"
import script from "./Transistor.vue?vue&type=script&lang=js&"
export * from "./Transistor.vue?vue&type=script&lang=js&"
import style0 from "./Transistor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports